import MyAPI from '@/api/my'
import { i18n } from '../../i18n'

const getUserData = ({ commit }, callback) => {
  // setTimeout(() => {  2021-04-13 yongkwan remove timeout
  MyAPI.getUserData(({ data, code }) => {
    if (code === 101) {
      // 유저 정보 삭제 TODO: 쿠폰 및 청약 철회내역, 구매내역도 삭제해야함
      commit('SET_USER_DATA', {
        loginID: '',
        nexonName: '',
        couponCount: 0,
        cartCount: 0,
        balance: {
          total: 0,
          currencyName: '',
          currencyUnit: i18n.$t('common.unit.unit_currency')
        }
      })
      // code가 101 때만 콜백을 실행한다 (로그인 상태 false로 변경)
      callback(code)
    } else {
      commit('SET_USER_DATA', data)
    }
  })
  // }, 1000)
}

const getUserBalance = ({ commit }) => {
  try {
    MyAPI.getUserBalance(response => {
      commit('SET_USER_BALANCE', response.data)
    })
  } catch (e) {
    console.log(e)
  }
}

const getPurchaseList = (
  { commit, getters, dispatch, rootGetters },
  params
) => {
  // pageNo가 0부터 시작해서 pageNo 를 response로 받을 때 +1 request로 보낼 때 -1을 한다.
  // 다른 곳 페이징과 달라서 해당 처리를 해둠
  const pageSize = 15
  const pageNo = params.pageNo - 1 || 0 // req pageNo

  if (params.reset) {
    commit('SET_PURCHASE', {
      purchaseList: [],
      totalCount: 0,
      totalPageCount: 0,
      pageNo: 1,
      pageSize
    })
  }

  const startDate = rootGetters['datepicker/startDate']
  const endDate = rootGetters['datepicker/endDate']

  const reqParams = {
    startDate,
    endDate,
    pageSize,
    pageNo
  }

  MyAPI.getPurchaseList(reqParams, responseData => {
    const { purchaseList, totalCount } = responseData.data

    commit('SET_PURCHASE', {
      purchaseList,
      totalCount,
      totalPageCount: Math.ceil(totalCount / pageSize),
      pageNo: pageNo + 1,
      pageSize
    })
  })
}

const getAlltemPurchaseProductList = (
  { commit, getters, dispatch, rootGetters },
  params
) => {
  MyAPI.getAlltemPurchaseProductList(
    {
      startDate: params.startDate,
      endDate: params.endDate
    },
    responseData => {
      commit('SET_ALLTEM_PURCHASE_PRODUCT_LIST', {
        alltemPurchaseProductList: responseData.data.purchaseProductList || []
      })
    }
  )
  // const responseData = {
  //   code: 0,
  //   message: 'success',
  //   data: {
  //     purchaseProductList: [
  //       {
  //         purchaseDate: '2023-12-12',
  //         purchaseDateTime: '2023-12-12 09:39:10',
  //         purchaseNumber: 70188866,
  //         purchaseTotalAmount: 15000,
  //         purchasePaidTotalAmount: 15000,
  //         purchaseFreeTotalAmount: 40,
  //         purchaseType: '토스페이',
  //         purchaseStatus: 1,
  //         coinName: '아라드 포인트',
  //         coinUnit: 'AP',
  //         purchaseTotalCount: 5,
  //         productName: '구매 제한 있어요 (5개)',
  //         refundDateTime: '-',
  //         refundTotalAmount: 10,
  //         refundPaidTotalAmount: 30,
  //         refundFreeTotalAmount: 0,
  //         currency: 'tt',
  //         totalExchangeAmount: 15,
  //         purchaseDetails: [
  //           {
  //             productName: '구매 제한 있어요 (5개)',
  //             purchaseCount: 1,
  //             // coinName: '아라드 포인트',
  //             // coinUnit: 'AP',
  //             purchaseAmount: 3000,
  //             purchasePaidAmount: 3000,
  //             // purchaseFreeAmount: 0,
  //             purchaseLiabilitiesAmount: 0
  //           },
  //           {
  //             productName: '구매 제한 있어요 (5개)',
  //             purchaseCount: 1,
  //             coinName: '아라드 포인트',
  //             coinUnit: 'AP',
  //             purchaseAmount: 3000,
  //             purchasePaidAmount: 3000,
  //             purchaseFreeAmount: 10,
  //             purchaseLiabilitiesAmount: 0
  //           },
  //           {
  //             productName: '구매 제한 있어요 (5개)',
  //             purchaseCount: 1,
  //             coinName: '아라드 포인트',
  //             coinUnit: 'AP',
  //             purchaseAmount: 3000,
  //             purchasePaidAmount: 3000,
  //             purchaseFreeAmount: 30,
  //             purchaseLiabilitiesAmount: 0
  //           }
  //         ]
  //       }
  //     ]
  //   }
  // }
  // commit('SET_ALLTEM_PURCHASE_PRODUCT_LIST', {
  //   alltemPurchaseProductList: responseData.data.purchaseProductList || []
  // })
}

const getWithdrawList = (
  { commit, getters, dispatch, rootGetters },
  params
) => {
  const pageSize = 15
  const pageNo = params.pageNo - 1 || 0 // req pageNo

  if (params.reset) {
    commit('SET_WITHDRAW', {
      purchaseWithdrawList: [],
      totalCount: 0,
      totalPageCount: 0,
      pageNo: 1,
      pageSize
    })
  }

  const startDate = rootGetters['datepicker/startDate']
  const endDate = rootGetters['datepicker/endDate']

  const reqParams = {
    startDate,
    endDate,
    pageSize,
    pageNo
  }

  MyAPI.getWithdrawList(reqParams, responseData => {
    const { purchaseWithdrawList, totalCount } = responseData.data

    commit('SET_WITHDRAW', {
      purchaseWithdrawList,
      totalCount,
      totalPageCount: Math.ceil(totalCount / pageSize),
      pageNo: pageNo + 1,
      pageSize
    })
  })

  // const { withdrawList } = getters['withdraw'],
  //   reqPoss = rootGetters['main/requestPossible']
  // if (reqPoss || withdrawList.length === 0) {
  //   if (reset) {
  //     commit('SET_WITHDRAW', { page: 0, withdrawList: [], last: false })
  //   }
  //   const { page, pageSize, last } = getters['withdraw']
  //   const startDate = rootGetters['datepicker/startDate'],
  //     endDate = rootGetters['datepicker/endDate']
  //   if (last === false) {
  //     MyAPI.getWithdrawList(
  //       {
  //         startDate,
  //         endDate,
  //         page,
  //         pageSize
  //       },
  //       responseData => {
  //         commit('SET_WITHDRAW', {
  //           page: page + 1,
  //           withdrawList: responseData.data.purchaseWithdrawList || []
  //         })
  //       }
  //     )
  //   }
  // } else if (reqPoss === false) {
  //   dispatch('main/setRequestPossible', true, { root: true })
  // }
}

const getCouponUsableList = (
  { commit, getters, dispatch, rootGetters },
  reset
) => {
  const couponUsableList = getters['couponUsableList'],
    reqPoss = rootGetters['main/requestPossible'],
    shopSeq = rootGetters['main/shopSeq']
  if (reqPoss || couponUsableList.length === 0) {
    if (reset) {
      commit('SET_COUPONUSABLE', {
        lastPurchaseProductCouponId: 0,
        couponUsableList: [],
        last: false,
        reset
      })
    }
    const { lastPurchaseProductCouponId, pageSize, last } = getters[
      'couponUsable'
    ]
    if (last === false) {
      MyAPI.getCouponUsableList(
        {
          shopSeq,
          lastPurchaseProductCouponId,
          pageSize
        },
        responseData => {
          commit('SET_COUPONUSABLE', {
            lastPurchaseProductCouponId:
              responseData.data.lastPurchaseProductCouponId,
            couponUsableList: responseData.data.couponInfoList || []
          })
        }
      )
    }
  } else if (reqPoss === false) {
    dispatch('main/setRequestPossible', true, { root: true })
  }
}

const getCouponUnusableList = (
  { commit, getters, dispatch, rootGetters },
  reset
) => {
  const couponUnusableList = getters['couponUnusableList'],
    reqPoss = rootGetters['main/requestPossible'],
    shopSeq = rootGetters['main/shopSeq']
  if (reqPoss || couponUnusableList.length === 0) {
    if (reset) {
      commit('SET_COUPONUNUSABLE', {
        lastPurchaseProductCouponId: 0,
        couponUnusableList: [],
        last: false,
        reset
      })
    }
    const { lastPurchaseProductCouponId, pageSize, last } = getters[
      'couponUnusable'
    ]
    if (last === false) {
      MyAPI.getCouponUnusableList(
        {
          shopSeq,
          lastPurchaseProductCouponId,
          pageSize
        },
        responseData => {
          commit('SET_COUPONUNUSABLE', {
            lastPurchaseProductCouponId:
              responseData.data.lastPurchaseProductCouponId,
            couponUnusableList: responseData.data.couponInfoList || []
          })
        }
      )
    }
  } else if (reqPoss === false) {
    dispatch('main/setRequestPossible', true, { root: true })
  }
}

const getRewardInfo = ({ commit }) => {
  MyAPI.getRewardInfo(({ data }) => {
    commit('SET_REWARDINFO', data)
  })
}

const setAlltemPurchaseEndDate = ({ commit }, endDate) => {
  commit('SET_ALLTEM_PURCHASE_END_DATE', endDate)
}

const setAlltemPurchaseStartDate = ({ commit }, startDate) => {
  commit('SET_ALLTEM_PURCHASE_START_DATE', startDate)
}

export default {
  getUserData,
  getUserBalance,
  getPurchaseList,
  getWithdrawList,
  getCouponUsableList,
  getCouponUnusableList,
  getRewardInfo,
  getAlltemPurchaseProductList,
  setAlltemPurchaseStartDate,
  setAlltemPurchaseEndDate
}
